export const isMac =
  typeof navigator !== "undefined" &&
  /mac/i.test(navigator.userAgentData?.platform || navigator.userAgent);

export const modKey = isMac ? "\u2318" : "Ctrl";

export const hasPhysicalKeyboard =
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(pointer: fine)").matches;

export const shortcut = (label, keys) =>
  hasPhysicalKeyboard ? `${label} (${keys})` : label;
